





























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { BaseImage, BaseLink } from '@shared/ui';
import { getStoryblokImageURL } from '@unified-commerce/gpc-vue-storefront-storyblok';

import CardSection from '~/components/CardSection/CardSection.vue';
import Container from '~/components/Container.vue';

interface IPromotionContentItem {
  _uid: string;
  title: string;
  description?: string;
  link: {
    cached_url: string;
  };
  button_text: string;
  image: {
    url: {
      filename: string;
      alt: string;
    };
  };
  image_mobile?: {
    filename: string;
  };
}

const MOBILE_BREAKPOINT = 768;

export default defineComponent({
  name: 'PromotionContent',
  components: {
    Container,
    CardSection,
    BaseImage,
    BaseLink,
  },
  props: {
    items: {
      type: Array as PropType<IPromotionContentItem[]>,
      default: () => [],
    },
  },
  setup() {
    function getSrcsets(item: IPromotionContentItem) {
      const imageSrcset = {
        src: getStoryblokImageURL(item.image.url.filename, {
          width: 600,
        }),
        width: MOBILE_BREAKPOINT,
        breakpoint: MOBILE_BREAKPOINT,
      };

      return item.image_mobile?.filename
        ? [
            {
              src: getStoryblokImageURL(item.image_mobile.filename, {
                width: 300,
              }),
              width: MOBILE_BREAKPOINT - 1,
              breakpoint: 0,
            },
            imageSrcset,
          ]
        : [imageSrcset];
    }

    return {
      getSrcsets,
    };
  },
});
